export const PRICE_KIND = Object.freeze({
  NET: 'net',
  GROSS: 'gross',
})
